import { useState } from "react";
import { ReactComponent as Ellipsis } from "src/assets/svg/ellipsis.svg";
import Button from "src/components/Button";
import Modal from "src/components/Modal/Modal";
import useLoader from "src/hooks/useLoader";
import { resetInterview } from "src/network/interview";
import { JobInterview } from "src/types";
import RejectModal from "../../../pages/job/components/RejectModal";
import ShortlistModal from "../../../pages/job/components/ShortlistModal";

interface IInterviewOperations {
  value: boolean;
  onChange: (id: number | undefined) => void;
  interview: JobInterview;
  onRefresh: () => void;
}

const InterviewOperations = ({ value, onChange, onRefresh, interview }: IInterviewOperations) => {
  const { email, id } = interview;

  // Reseting logic
  const [reseting, setReseting] = useState(false);
  const closeReset = () => {
    setReseting(false);
    onChange(undefined);
  };
  const reset = async () => {
    await resetInterview(id);
    await onRefresh?.();
  };
  const { ldng: _reset, loading: _reseting } = useLoader(reset, {
    errorMsg: "Error reseting interview",
    successMsg: "Interview was reset"
  });

  // Rejecting logic
  const [rejecting, setRejecting] = useState(false);
  const _setRejecting = (b: boolean) => {
    if (b) {
      setRejecting(true);
      return;
    }
    setRejecting(false);
    onChange(undefined);
  };

  // Approving logic logic
  const [approving, setApproving] = useState(false);
  const _setApproving = (b: boolean) => {
    if (b) {
      setApproving(true);
      return;
    }
    setApproving(false);
    onChange(undefined);
  };

  const operations = [
    { name: "Move to “Shortlisted Talents”", action: () => setApproving(true) },
    { name: "Reject Candidate", action: () => setRejecting(true) },
    { name: "Reset Interview", action: () => setReseting(true) }
  ];

  return (
    <div className="relative z-10">
      <Ellipsis
        onClick={() => onChange(value ? undefined : id)}
        className={`w-9 h-9 cursor-pointer shrink-0 ${value && "fill-[#CCCCCC]"} hover:fill-[#CCCCCC]`}
      />
      {value && (
        <div className="absolute top-11 w-[230px]  -translate-x-[100%]  bg-white rounded-lg shadow-lg overflow-hidden">
          {operations.map(({ name, action }) => (
            <button
              key={name}
              onClick={action}
              type="button"
              className="py-4 border-b-[1px] border-[#CCCCCC] px-[10px] w-full text-start font-poppins font-semibold text-sm hover:bg-[#e1e1e1]"
            >
              {name}
            </button>
          ))}
        </div>
      )}
      {/* Modals */}
      <Modal open={reseting} onChange={closeReset} className="!w-[500px] text-center">
        <p className="font-poppins text-lg font-semibold mt-6">
          Are you sure you want to reset interview for <span className="text-odfblue">{email}</span>
          ?
        </p>
        <p className="mt-6 text-base font-medium text-inactive-gray">
          An email notification will be sent to the candidate regarding the rescheduled interview.
        </p>
        <div className="flex items-center justify-center w-full mt-6 gap-6">
          <Button
            className="!w-fit !px-6 !h-[56px]  !py-4 !rounded-3xl"
            onClick={_reset}
            loading={_reseting}
          >
            Reset Interview
          </Button>
          <Button
            className="!w-fit !px-6 !h-[56px] !py-4 !rounded-3xl"
            onClick={closeReset}
            variant="white_blue"
          >
            Cancel
          </Button>
        </div>
      </Modal>

      <RejectModal
        interview={interview}
        open={rejecting}
        setOpen={_setRejecting}
        onReject={onRefresh}
      />

      <ShortlistModal
        interview={interview}
        open={approving}
        setOpen={_setApproving}
        onShortlist={onRefresh}
      />
    </div>
  );
};

export default InterviewOperations;
